/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Idnes_RealityInputs */

const cs_enum_idnes_reality = /** @type {(inputs: Enum_Idnes_RealityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iDNES Reality`)
};

const en_enum_idnes_reality = /** @type {(inputs: Enum_Idnes_RealityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iDNES Reality`)
};

/**
* | output |
* | --- |
* | "iDNES Reality" |
*
* @param {Enum_Idnes_RealityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_idnes_reality = /** @type {((inputs?: Enum_Idnes_RealityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Idnes_RealityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_idnes_reality(inputs)
	return cs_enum_idnes_reality(inputs)
});